export const calculateDuration = (start: string, end: string): string => {
  const startTime = new Date(start).getTime();
  const endTime = new Date(end).getTime();

  if (isNaN(startTime) || isNaN(endTime)) {
    throw new Error("Invalid date string provided");
  }

  const diffInMs = Math.abs(endTime - startTime);

  return `${diffInMs} ms`;
};